import { render, staticRenderFns } from "./editTag.vue?vue&type=template&id=c4a3d7aa&scoped=true"
import script from "./editTag.vue?vue&type=script&lang=js"
export * from "./editTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4a3d7aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c4a3d7aa')) {
      api.createRecord('c4a3d7aa', component.options)
    } else {
      api.reload('c4a3d7aa', component.options)
    }
    module.hot.accept("./editTag.vue?vue&type=template&id=c4a3d7aa&scoped=true", function () {
      api.rerender('c4a3d7aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/orderList/order/orderTag/editTag.vue"
export default component.exports